import { render, staticRenderFns } from "./OpportunityResourceMedia.vue?vue&type=template&id=57dc78a0"
import script from "./OpportunityResourceMedia.vue?vue&type=script&lang=js"
export * from "./OpportunityResourceMedia.vue?vue&type=script&lang=js"
import style0 from "./OpportunityResourceMedia.vue?vue&type=style&index=0&id=57dc78a0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports